// Puente entre "Seguimiento de Intercambios" y la burbuja de Alertas de
// Mejoramientos. La tabla no duplica el envío de mails ni el modal: pide la
// acción y la burbuja (que ya tiene el flujo y actualiza el FormContext) la
// ejecuta.
export const EVENTO_ACCION_ALERTA = 'alertas-mejoramientos:accion';

export const pedirAccionAlerta = (detalle) => {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(EVENTO_ACCION_ALERTA, { detail: detalle }));
};
